
export default () => ({
	specimen: {}
})